// Copyright 2005-2014 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var dom   = require('./dom'), px=dom.px, timeout=dom.timeout, URL=dom.URL, doc=dom.doc;
var lib   = require('./lib'), merge_into=lib.merge_into, map=lib.map;
var plat  = require('./platform'), PageCoords=plat.PageCoords;
var Prefs = require('./prefs');
var prnt  = require('./print'), printf=prnt.printf;
var piles = require('./piles'), up=piles.up, down=piles.down, clubs=piles.clubs, diamonds=piles.diamonds, hearts=piles.hearts, spades=piles.spades,
                              ace=piles.ace, jack=piles.jack, queen=piles.queen, king=piles.king, joker=piles.joker, base64=piles.base64,
                              card=piles.card, init_deck=piles.init_deck;
var piles_ui = require('./piles-ui'), aspect=piles_ui.aspect;


class pile_game_ui_browser extends piles_ui.pile_game_ui {
    constructor(game) {
        super(...arguments);

        this.div = { activate: this.game.piles_ui.activate, piles_style: doc.id("piles-style") };

        this.create_game_div();

        this.init_card_menus(this.cardbacks);

        this.init_control_panel();

        window.onresize = this.handle_resize.bind(this);

        this.div.activate.parentNode.style.minHeight = px(this.last_size.h); // lets us scroll down nicely at the start of a game.

        plat.register_key_events(document, this.pile_finder_key_handler.bind(this));

    }

    create_game_div() {
            if (this.game_layout() && this.game_layout().grid) // Create the game HTML.
                this.div.activate.appendChild(this.div.card_area=doc(["div", {id:"card-area"}]));

    }

    update_card_sizes_and_positions() {
            var update_if_changed = function(target, props) {
                for (var p in props)
                    if (target[p] != props[p])
                        target[p] = props[p];
            };

            for (var p=0; p<this.game.piles.length; p++)
                if (this.game.piles[p].ui.coords) // beleaguered and fortress don't lay out their "reserve" pile.
                    update_if_changed(this.game.piles[p].ui.div.style, { left:   this.game.piles[p].ui.coords.x * this.cardset.width  + "px",
                                                                         top:    this.game.piles[p].ui.coords.y * this.cardset.height + "px",
                                                                         width:  this.cardset.width  + "px",
                                                                         height: this.cardset.height + "px" });

            update_if_changed(this.div.card_area.style, { width:  this.size.width  * this.cardset.width  + "px",
                                                          height: this.size.height * this.cardset.height + "px" });
    }

    content_size() { return { width:  plat.windowWidth(), // this.div.activate.clientWidth
                              height: plat.windowHeight() } }

    init_card_menus() {
            var input = doc.id("card_sizes").getElementsByTagName("INPUT");
            for (var i=0; i<input.length; i++) {
                input[i].checked = (this.cardset_default ? this.cardset_default.size : '') == input[i].value;
                input[i].onclick = function(event) {
                    var e = new plat.event(event);
                    if (!e.target.checked) return;
                    Prefs.set("cardset", e.target.value || undefined);
                    this.cardset_default = this.cardsets[this.theme][Prefs.v.cardset];
                    this.update_cardset(this.cardset_default || this.best_cardset(this.cardsets[this.theme]));
                }.bind(this);
            }
            doc.id("menu-theme").className = this.theme;

            var input = doc.id("card_backs").getElementsByTagName("INPUT");
            for (var i=0; i<input.length; i++) {
                input[i].checked = this.cardbacks.set(input[i].value);
                input[i].parentNode.classList.set(input[i].checked, "selected");
                input[i].onclick = function(event) {
                    var e = new plat.event(event);
                    e.target.parentNode.classList.set(e.target.checked, "selected");
                    this.cardbacks.set(e.target.value, e.target.checked);
                    this.update_cardbacks();
                }.bind(this);
            }

            for (let i of doc.id("card_themes").getElementsByTagName("INPUT")) {
                i.checked = this.theme == i.value;
                i.onclick = (event) => {
                    var e = new plat.event(event);
                    if (!e.target.checked) return;
                    this.update_theme(Prefs.set("cardtheme", e.target.value || undefined));
                };
            }

            if (this.holiday) {
                this.holiday.ui = {};
                if (this.holiday.theme)
                    doc.id(`card-theme-${this.holiday.theme}`).classList.remove("hidden");
                if (this.holiday.back) {
                    this.holiday.ui.menu = { checkbox:          doc.id('holiday-card-backs').getElementsByTagName('INPUT')[0],
                                             item:              doc.id('holiday-card-backs'),
                                             non_holiday_backs: doc.id('card_backs'),
                                             image:             doc.id('holiday-card-back-image'),
                                           };
                    this.holiday.ui.menu.item.classList.remove("hidden");
                    this.holiday.ui.menu.non_holiday_backs.classList.add("disabled");
                    this.holiday.ui.menu.image.classList.add(`c-${this.holiday.back}`);
                    this.holiday.ui.menu.checkbox.checked = true;
                    this.holiday.ui.menu.checkbox.onclick = () => { this.update_holiday(!this.holiday.enabled) };
                }
            }
            if (URL.param.themes)
                for (let t of Object.keys(this.cardsets))
                    doc.id(`card-theme-${t}`).classList.remove("hidden");
    }

    update_theme(th) {
            this.update_cardset(this.cardsets[this.theme = th || URL.param.theme || Prefs.v.cardtheme || this.default_theme][this.cardset.size])
            doc.id("menu-theme").className = this.theme;

            for (let i of doc.id("card_themes").getElementsByTagName("INPUT"))
                i.checked = this.theme == i.value;
    }

    update_holiday(enable) {
            this.holiday.enabled = enable;
            if (this.holiday.theme)
                this.update_theme(this.holiday.enabled ? this.holiday.theme : null);
            if (this.holiday.back) {
                this.holiday.ui.menu.checkbox.checked = enable;
                this.holiday.ui.menu.non_holiday_backs.classList.set(enable, "disabled");
                this.update_cardbacks();
            }
            if (this.game.normal_cards_button)
                this.game.normal_cards_button.text(this.holiday.enabled ? `Normal ${this.holiday.ui.cards}` : `Holiday ${this.holiday.ui.cards}`);
    }

    init_control_panel() {
            let cards = this.holiday && !this.holiday.theme && this.holiday.back ? "Card Backs" : "Cards";
            if (this.holiday) this.holiday.ui.cards = cards;
            this.game.button({ id: "normal_cards", name:`Normal ${cards}`, help:`Toggle Today's Holiday Themed ${cards}`, accent: true, if:() => this.holiday,
                               fn:() => { this.update_holiday(!this.holiday.enabled) } })
            doc.appendTo(this.game.control_panel);
    }

    backs_visible(backs_are_visible) {
            doc.id("menu-deck-back").classList.set(!backs_are_visible, 'hidden')
    }

    last_size = {w:plat.windowWidth(), h:plat.windowHeight()};
    handle_resize(event) {
            // Stupid IE calls this repeatedly whenever anything on the page resizes, not just the window.
            // So we have to make sure we really changed size to avoid unnecessary work.
            var new_size = { w: plat.windowWidth(), h: plat.windowHeight() };
            if (this.last_size.w == new_size.w && this.last_size.h == new_size.h)
                return;
            this.last_size = new_size;
            this.resize(new_size);
    }

    resize(new_size) {
            this.lay_out(); // If our aspect ratio changed then we need to possibly choose a better layout

            if (!this.cardset_default)
                this.update_cardset(this.best_cardset(this.cardsets[this.theme]));
            this.div.activate.parentNode.style.minHeight = px(new_size.h);
    }

    // Given the following layouts, find the first whose constraints match our screen
    find_layout(layouts) {
            let l = layouts.find(layout => window.matchMedia(this.media_query_for_constraints(layout.constraints)).matches);
            return (l || layouts[0]).layout;
    }

    media_query_for_constraints(constraints) {
            return (constraints.wider && constraints.skinnier ? `(${constraints.wider} <= aspect-ratio <= ${constraints.skinnier})` :
                    constraints.wider                         ? `(${constraints.wider} <= aspect-ratio)`                            :
                    constraints.skinnier                      ? `                        (aspect-ratio <= ${constraints.skinnier})`
                                                              : (()=>{throw `Missing wider and/or skinnier on constraints in ${JSON.stringinfy(constraints)}`})()
                   ) + (constraints.mobile ? ` and (pointer: coarse)` : ``); // Use touchscreen as a shorthand for mobile
    }

    pile_finder_key_handler(event) {
            switch (event.key) {
            case 'f':
                if (this.deck_play)
                    this.deck_play();
                return false;
            case '#':
                if (window.debug) {
                    for (var p=0; p<this.game.piles.length; p++) {
                        if (this.game.piles[p].ui.label) {
                            this.game.piles[p].ui.div.removeChild(this.game.piles[p].ui.label);
                            delete this.game.piles[p].ui.label;
                            continue;
                        }
                        this.game.piles[p].ui.label = doc.el("div", {style:{ position:"absolute",
                                                                             top:0, left:0,
                                                                             fontSize:this.cardset.height+"px",
                                                                             zIndex:2000,
                                                                             color:"yellow"}},
                                                             doc.text(base64.to(p)));
                        this.game.piles[p].ui.div.appendChild(this.game.piles[p].ui.label);
                    }
                    return false;
                }
            }
            return true; // let someone else handle it.
    }

    on_pause() {
                class over_time {
                  constructor(dv__dt, set, get) {
                    this.dv__dt = dv__dt;
                    this.set = set;
                    this.get = get;
                  }
                  timeout() {
                    var dt = 30/1000;
                    var g = this.get();
                    if (Math.abs(this.to-g) < this.dv__dt*dt) {
                        this.set(this.to);
                        delete this.timer;
                    } else {
                        this.set(g + this.dv__dt * dt * (g > this.to ? -1 : +1));
                        this.timer = timeout(30, () => this.timeout());
                    }
                  }
                  fade_to(new_to) {
                    if (new_to) this.to = new_to
                    if (!this.timer) this.timeout();
                  }
                }

                var paused = this.div.pause = doc.el("div", { id: "paused", className:"highscore", style: { position: "absolute" } }, doc.text("Paused..."));
                doc.appendTo(this.div.activate, paused);
                paused.style.left = px(Math.max(0, this.div.activate.clientWidth/2  - paused.clientWidth/2));
                paused.style.top  = px(Math.max(0, this.div.activate.clientHeight/2 - paused.clientHeight/2));

                if (!this.pause_fader)
                    this.pause_fader = new over_time(3, function (p) { this.set_opacity(p) }.bind(this), function () { return this.opacity == undefined ? 1 : this.opacity }.bind(this));
                this.pause_fader.fade_to(.1);
    }

    on_unpause() {
            var paused = this.div.pause;
            if (paused) paused.parentNode.removeChild(paused);
            delete this.div.pause;
            if (this.pause_fader)
                this.pause_fader.fade_to(1);
    }

    reflow(element) {
            // see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
            element.offsetHeight;
    }

    game_restored() {
            const remove = () => {
                if (this.div.restored_message)
                    this.div.activate.removeChild(this.div.restored_message);
                delete this.div.restored_message;
            }
            remove();
            doc.appendTo(this.div.activate, this.div.restored_message = doc(["div", { className: "restored-message" }, "Game Restored"]))
            this.div.restored_message.onanimationend = remove;
    }
}

class pile_ui_browser extends piles_ui.pile_ui {
    constructor(name, pile) {
        super(name, pile);
        this.div = pile.game.ui.div.card_area.appendChild(doc(["div", {id:name, className:"pile", style: {position:"absolute"}} ]));
    }
    //this.add_empty_pile = function() {}
    update() {
            this.div.title = this.pile.title && this.pile.pile.length > 0 ? this.pile.pile.length : "";
    }

    fix_event(event, element) {
            var e = new plat.event(event, element);
            e.targetX /= this.pile.game.ui.cardset.width;
            e.targetY /= this.pile.game.ui.cardset.height;
            return e;
    }

    set_drag_start_handler(handler) {
            this.div.ontouchstart = this.div.onmousedown =
                function(event) {
                    event = event || window.event
                    if (event.changedTouches)
                        event = event.changedTouches[0];
                    var ret = handler(this.fix_event(event, this.div));
                    if (ret === false)
                        if ("stopPropagation" in event)
                            event.stopPropagation();
                    else if ("cancelBubble" in event)
                        event.cancelBubble = true;
                    return ret;
                }.bind(this);
    }

    set_drag_handler(handler) {
            this.saved = { move       : document.onmousemove,
                           up         : document.onmouseup,
                           touch_end  : document.ontouchend,
                           touch_move : document.ontouchmove };
            document.ontouchmove = document.onmousemove = function(event) {
                if (event && event.changedTouches) {
                    event = event.changedTouches[0];
                }
                return handler(this.fix_event(event,this.div));
            }.bind(this);
    }
    set_drag_end_handler(handler) {
            document.ontouchend = document.onmouseup = function(event) {
                if (event && event.changedTouches) {
                    event = event.changedTouches[0];
                }
                return handler(this.fix_event(event,this.div));
            }.bind(this);
    }
    drag_complete() {
            document.ontouchmove = this.saved.touch_move;
            document.ontouchend  = this.saved.touch_end;
            document.onmousemove = this.saved.move;
            document.onmouseup   = this.saved.up;
    }
}

class card_ui_browser extends piles_ui.card_ui {
    constructor(card, game) {
        super(card, game);
    }
    redraw() {
            if (!this.front) this.front = document.createElement("div");
            this.front.className = "card " + this.cardset.size + " " + this.cardset.theme + " c-" + this.card.string;
            if (this.card.deck) { // the highlight, empty-pile and foundation icons have no back
                if (!this.back) this.back = document.createElement("div");
                this.back.className = "card " + this.cardset.size + " " + "back" + " c-" + this.card.deck.design;
            }
    }

    set_opacity(front, back) {
            if (this.front) doc.opacity(this.front, front);
            if (this.back)  doc.opacity(this.back,  back);
    }

    set_face(face) {
            if (!this.front && !this.back) this.redraw(); // hack around bad initialiation.
            var old_img = this.img;
            this.img = face == up ? this.front : this.back;
            if (old_img && old_img.parentNode)
                old_img.parentNode.replaceChild(this.img, old_img);
            this.img.style["-apple-dashboard-region"] = "dashboard-region(control rectangle)";
            this.set_cardset(this.cardset);
            if (this.pile_ui && this.coords)
                this.set_position(this.pile_ui, this.coords, !!this.animate);
    }

    hide() {
            if (this.div) {
                this.div.removeChild(this.img);
                this.div = undefined;
                this.piles_ui = undefined;
                this.coords = undefined;
            }
    }

    show() { /*implied by setting the div in set_position*/ }

    set_cardset(cardset) {
            this.cardset = cardset;
            this.img.style.position = "absolute";
            this.img.style.width    = px(cardset.width);
            this.img.style.height   = px(cardset.height);
    }

    set_position(pile_ui, coords, animating) {
            var div = pile_ui.div;
            if (animating && plat.ie <= 7) { // Work around IE7 zIndex non-standardness
                var t = PageCoords(document.body), f = pile_ui.coords;
                coords = { x: coords.x + f.x - t.x, y: coords.y + f.y - t.y, z: coords.z };
                div = document.body;
            }
            this.img.style.left     = px(Math.floor(coords.x * this.cardset.width));
            this.img.style.top      = px(Math.floor(coords.y * this.cardset.height));
            this.img.style.zIndex   = 2*coords.z;
            if (!this.div || this.div != div) {
                this.div = div;
                this.div.appendChild(this.img);
            }
    }

    set_cursor(cursor) {
            this.img.style.cursor = cursor;
    }
}

module.exports = {
    pile_game_ui: pile_game_ui_browser,
    pile_ui: pile_ui_browser,
    card_ui: card_ui_browser,
    grid: piles_ui.grid
};
// Copyright 2005-2014 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var dom   = require('./dom'), px=dom.px, timeout=dom.timeout, URL=dom.URL, doc=dom.doc;
var lib   = require('./lib'), merge_into=lib.merge_into, map=lib.map;
var plat  = require('./platform'), PageCoords=plat.PageCoords;
var Prefs = require('./prefs');
var prnt  = require('./print'), printf=prnt.printf;
var piles = require('./piles'), up=piles.up, down=piles.down, clubs=piles.clubs, diamonds=piles.diamonds, hearts=piles.hearts, spades=piles.spades,
                              ace=piles.ace, jack=piles.jack, queen=piles.queen, king=piles.king, joker=piles.joker, base64=piles.base64,
                              card=piles.card, init_deck=piles.init_deck;
var piles_ui = require('./piles-ui'), aspect=piles_ui.aspect;


class pile_game_ui_browser extends piles_ui.pile_game_ui {
    constructor(game) {
        super(...arguments);

        this.div = { activate: this.game.piles_ui.activate, piles_style: doc.id("piles-style") };

        this.create_game_div();

        this.init_card_menus(this.cardbacks);

        this.init_control_panel();

        window.onresize = this.handle_resize.bind(this);

        this.div.activate.parentNode.style.minHeight = px(this.last_size.h); // lets us scroll down nicely at the start of a game.

        plat.register_key_events(document, this.pile_finder_key_handler.bind(this));

    }

    create_game_div() {
            if (this.game_layout() && this.game_layout().grid) // Create the game HTML.
                this.div.activate.appendChild(this.div.card_area=doc(["div", {id:"card-area"}]));

    }

    update_card_sizes_and_positions() {
            var update_if_changed = function(target, props) {
                for (var p in props)
                    if (target[p] != props[p])
                        target[p] = props[p];
            };

            for (var p=0; p<this.game.piles.length; p++)
                if (this.game.piles[p].ui.coords) // beleaguered and fortress don't lay out their "reserve" pile.
                    update_if_changed(this.game.piles[p].ui.div.style, { left:   this.game.piles[p].ui.coords.x * this.cardset.width  + "px",
                                                                         top:    this.game.piles[p].ui.coords.y * this.cardset.height + "px",
                                                                         width:  this.cardset.width  + "px",
                                                                         height: this.cardset.height + "px" });

            update_if_changed(this.div.card_area.style, { width:  this.size.width  * this.cardset.width  + "px",
                                                          height: this.size.height * this.cardset.height + "px" });
    }

    content_size() { return { width:  plat.windowWidth(), // this.div.activate.clientWidth
                              height: plat.windowHeight() } }

    init_card_menus() {
            var input = doc.id("card_sizes").getElementsByTagName("INPUT");
            for (var i=0; i<input.length; i++) {
                input[i].checked = (this.cardset_default ? this.cardset_default.size : '') == input[i].value;
                input[i].onclick = function(event) {
                    var e = new plat.event(event);
                    if (!e.target.checked) return;
                    Prefs.set("cardset", e.target.value || undefined);
                    this.cardset_default = this.cardsets[this.theme][Prefs.v.cardset];
                    this.update_cardset(this.cardset_default || this.best_cardset(this.cardsets[this.theme]));
                }.bind(this);
            }
            doc.id("menu-theme").className = this.theme;

            var input = doc.id("card_backs").getElementsByTagName("INPUT");
            for (var i=0; i<input.length; i++) {
                input[i].checked = this.cardbacks.set(input[i].value);
                input[i].parentNode.classList.set(input[i].checked, "selected");
                input[i].onclick = function(event) {
                    var e = new plat.event(event);
                    e.target.parentNode.classList.set(e.target.checked, "selected");
                    this.cardbacks.set(e.target.value, e.target.checked);
                    this.update_cardbacks();
                }.bind(this);
            }

            for (let i of doc.id("card_themes").getElementsByTagName("INPUT")) {
                i.checked = this.theme == i.value;
                i.onclick = (event) => {
                    var e = new plat.event(event);
                    if (!e.target.checked) return;
                    this.update_theme(Prefs.set("cardtheme", e.target.value || undefined));
                };
            }

            if (this.holiday) {
                this.holiday.ui = {};
                if (this.holiday.theme)
                    doc.id(`card-theme-${this.holiday.theme}`).classList.remove("hidden");
                if (this.holiday.back) {
                    this.holiday.ui.menu = { checkbox:          doc.id('holiday-card-backs').getElementsByTagName('INPUT')[0],
                                             item:              doc.id('holiday-card-backs'),
                                             non_holiday_backs: doc.id('card_backs'),
                                             image:             doc.id('holiday-card-back-image'),
                                           };
                    this.holiday.ui.menu.item.classList.remove("hidden");
                    this.holiday.ui.menu.non_holiday_backs.classList.add("disabled");
                    this.holiday.ui.menu.image.classList.add(`c-${this.holiday.back}`);
                    this.holiday.ui.menu.checkbox.checked = true;
                    this.holiday.ui.menu.checkbox.onclick = () => { this.update_holiday(!this.holiday.enabled) };
                }
            }
            if (URL.param.themes)
                for (let t of Object.keys(this.cardsets))
                    doc.id(`card-theme-${t}`).classList.remove("hidden");
    }

    update_theme(th) {
            this.update_cardset(this.cardsets[this.theme = th || URL.param.theme || Prefs.v.cardtheme || this.default_theme][this.cardset.size])
            doc.id("menu-theme").className = this.theme;

            for (let i of doc.id("card_themes").getElementsByTagName("INPUT"))
                i.checked = this.theme == i.value;
    }

    update_holiday(enable) {
            this.holiday.enabled = enable;
            if (this.holiday.theme)
                this.update_theme(this.holiday.enabled ? this.holiday.theme : null);
            if (this.holiday.back) {
                this.holiday.ui.menu.checkbox.checked = enable;
                this.holiday.ui.menu.non_holiday_backs.classList.set(enable, "disabled");
                this.update_cardbacks();
            }
            if (this.game.normal_cards_button)
                this.game.normal_cards_button.text(this.holiday.enabled ? `Normal ${this.holiday.ui.cards}` : `Holiday ${this.holiday.ui.cards}`);
    }

    init_control_panel() {
            let cards = this.holiday && !this.holiday.theme && this.holiday.back ? "Card Backs" : "Cards";
            if (this.holiday) this.holiday.ui.cards = cards;
            this.game.button({ id: "normal_cards", name:`Normal ${cards}`, help:`Toggle Today's Holiday Themed ${cards}`, accent: true, if:() => this.holiday,
                               fn:() => { this.update_holiday(!this.holiday.enabled) } })
            doc.appendTo(this.game.control_panel);
    }

    backs_visible(backs_are_visible) {
            doc.id("menu-deck-back").classList.set(!backs_are_visible, 'hidden')
    }

    last_size = {w:plat.windowWidth(), h:plat.windowHeight()};
    handle_resize(event) {
            // Stupid IE calls this repeatedly whenever anything on the page resizes, not just the window.
            // So we have to make sure we really changed size to avoid unnecessary work.
            var new_size = { w: plat.windowWidth(), h: plat.windowHeight() };
            if (this.last_size.w == new_size.w && this.last_size.h == new_size.h)
                return;
            this.last_size = new_size;
            this.resize(new_size);
    }

    resize(new_size) {
            this.lay_out(); // If our aspect ratio changed then we need to possibly choose a better layout

            if (!this.cardset_default)
                this.update_cardset(this.best_cardset(this.cardsets[this.theme]));
            this.div.activate.parentNode.style.minHeight = px(new_size.h);
    }

    // Given the following layouts, find the first whose constraints match our screen
    find_layout(layouts) {
            let l = layouts.find(layout => window.matchMedia(this.media_query_for_constraints(layout.constraints)).matches);
            return (l || layouts[0]).layout;
    }

    media_query_for_constraints(constraints) {
            return (constraints.wider && constraints.skinnier ? `(${constraints.wider} <= aspect-ratio <= ${constraints.skinnier})` :
                    constraints.wider                         ? `(${constraints.wider} <= aspect-ratio)`                            :
                    constraints.skinnier                      ? `                        (aspect-ratio <= ${constraints.skinnier})`
                                                              : (()=>{throw `Missing wider and/or skinnier on constraints in ${JSON.stringinfy(constraints)}`})()
                   ) + (constraints.mobile ? ` and (pointer: coarse)` : ``); // Use touchscreen as a shorthand for mobile
    }

    pile_finder_key_handler(event) {
            switch (event.key) {
            case 'f':
                if (this.deck_play)
                    this.deck_play();
                return false;
            case '#':
                if (window.debug) {
                    for (var p=0; p<this.game.piles.length; p++) {
                        if (this.game.piles[p].ui.label) {
                            this.game.piles[p].ui.div.removeChild(this.game.piles[p].ui.label);
                            delete this.game.piles[p].ui.label;
                            continue;
                        }
                        this.game.piles[p].ui.label = doc.el("div", {style:{ position:"absolute",
                                                                             top:0, left:0,
                                                                             fontSize:this.cardset.height+"px",
                                                                             zIndex:2000,
                                                                             color:"yellow"}},
                                                             doc.text(base64.to(p)));
                        this.game.piles[p].ui.div.appendChild(this.game.piles[p].ui.label);
                    }
                    return false;
                }
            }
            return true; // let someone else handle it.
    }

    on_pause() {
                class over_time {
                  constructor(dv__dt, set, get) {
                    this.dv__dt = dv__dt;
                    this.set = set;
                    this.get = get;
                  }
                  timeout() {
                    var dt = 30/1000;
                    var g = this.get();
                    if (Math.abs(this.to-g) < this.dv__dt*dt) {
                        this.set(this.to);
                        delete this.timer;
                    } else {
                        this.set(g + this.dv__dt * dt * (g > this.to ? -1 : +1));
                        this.timer = timeout(30, () => this.timeout());
                    }
                  }
                  fade_to(new_to) {
                    if (new_to) this.to = new_to
                    if (!this.timer) this.timeout();
                  }
                }

                var paused = this.div.pause = doc.el("div", { id: "paused", className:"highscore", style: { position: "absolute" } }, doc.text("Paused..."));
                doc.appendTo(this.div.activate, paused);
                paused.style.left = px(Math.max(0, this.div.activate.clientWidth/2  - paused.clientWidth/2));
                paused.style.top  = px(Math.max(0, this.div.activate.clientHeight/2 - paused.clientHeight/2));

                if (!this.pause_fader)
                    this.pause_fader = new over_time(3, function (p) { this.set_opacity(p) }.bind(this), function () { return this.opacity == undefined ? 1 : this.opacity }.bind(this));
                this.pause_fader.fade_to(.1);
    }

    on_unpause() {
            var paused = this.div.pause;
            if (paused) paused.parentNode.removeChild(paused);
            delete this.div.pause;
            if (this.pause_fader)
                this.pause_fader.fade_to(1);
    }

    reflow(element) {
            // see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
            element.offsetHeight;
    }

    game_restored() {
            const remove = () => {
                if (this.div.restored_message)
                    this.div.activate.removeChild(this.div.restored_message);
                delete this.div.restored_message;
            }
            remove();
            doc.appendTo(this.div.activate, this.div.restored_message = doc(["div", { className: "restored-message" }, "Game Restored"]))
            this.div.restored_message.onanimationend = remove;
    }
}

class pile_ui_browser extends piles_ui.pile_ui {
    constructor(name, pile) {
        super(name, pile);
        this.div = pile.game.ui.div.card_area.appendChild(doc(["div", {id:name, className:"pile", style: {position:"absolute"}} ]));
    }
    //this.add_empty_pile = function() {}
    update() {
            this.div.title = this.pile.title && this.pile.pile.length > 0 ? this.pile.pile.length : "";
    }

    fix_event(event, element) {
            var e = new plat.event(event, element);
            e.targetX /= this.pile.game.ui.cardset.width;
            e.targetY /= this.pile.game.ui.cardset.height;
            return e;
    }

    set_drag_start_handler(handler) {
            this.div.ontouchstart = this.div.onmousedown =
                function(event) {
                    event = event || window.event
                    if (event.changedTouches)
                        event = event.changedTouches[0];
                    var ret = handler(this.fix_event(event, this.div));
                    if (ret === false)
                        if ("stopPropagation" in event)
                            event.stopPropagation();
                    else if ("cancelBubble" in event)
                        event.cancelBubble = true;
                    return ret;
                }.bind(this);
    }

    set_drag_handler(handler) {
            this.saved = { move       : document.onmousemove,
                           up         : document.onmouseup,
                           touch_end  : document.ontouchend,
                           touch_move : document.ontouchmove };
            document.ontouchmove = document.onmousemove = function(event) {
                if (event && event.changedTouches) {
                    event = event.changedTouches[0];
                }
                return handler(this.fix_event(event,this.div));
            }.bind(this);
    }
    set_drag_end_handler(handler) {
            document.ontouchend = document.onmouseup = function(event) {
                if (event && event.changedTouches) {
                    event = event.changedTouches[0];
                }
                return handler(this.fix_event(event,this.div));
            }.bind(this);
    }
    drag_complete() {
            document.ontouchmove = this.saved.touch_move;
            document.ontouchend  = this.saved.touch_end;
            document.onmousemove = this.saved.move;
            document.onmouseup   = this.saved.up;
    }
}

class card_ui_browser extends piles_ui.card_ui {
    constructor(card, game) {
        super(card, game);
    }
    redraw() {
            if (!this.front) this.front = document.createElement("div");
            this.front.className = "card " + this.cardset.size + " " + this.cardset.theme + " c-" + this.card.string;
            if (this.card.deck) { // the highlight, empty-pile and foundation icons have no back
                if (!this.back) this.back = document.createElement("div");
                this.back.className = "card " + this.cardset.size + " " + "back" + " c-" + this.card.deck.design;
            }
    }

    set_opacity(front, back) {
            if (this.front) doc.opacity(this.front, front);
            if (this.back)  doc.opacity(this.back,  back);
    }

    set_face(face) {
            if (!this.front && !this.back) this.redraw(); // hack around bad initialiation.
            var old_img = this.img;
            this.img = face == up ? this.front : this.back;
            if (old_img && old_img.parentNode)
                old_img.parentNode.replaceChild(this.img, old_img);
            this.img.style["-apple-dashboard-region"] = "dashboard-region(control rectangle)";
            this.set_cardset(this.cardset);
            if (this.pile_ui && this.coords)
                this.set_position(this.pile_ui, this.coords, !!this.animate);
    }

    hide() {
            if (this.div) {
                this.div.removeChild(this.img);
                this.div = undefined;
                this.piles_ui = undefined;
                this.coords = undefined;
            }
    }

    show() { /*implied by setting the div in set_position*/ }

    set_cardset(cardset) {
            this.cardset = cardset;
            this.img.style.position = "absolute";
            this.img.style.width    = px(cardset.width);
            this.img.style.height   = px(cardset.height);
    }

    set_position(pile_ui, coords, animating) {
            var div = pile_ui.div;
            if (animating && plat.ie <= 7) { // Work around IE7 zIndex non-standardness
                var t = PageCoords(document.body), f = pile_ui.coords;
                coords = { x: coords.x + f.x - t.x, y: coords.y + f.y - t.y, z: coords.z };
                div = document.body;
            }
            this.img.style.left     = px(Math.floor(coords.x * this.cardset.width));
            this.img.style.top      = px(Math.floor(coords.y * this.cardset.height));
            this.img.style.zIndex   = 2*coords.z;
            if (!this.div || this.div != div) {
                this.div = div;
                this.div.appendChild(this.img);
            }
    }

    set_cursor(cursor) {
            this.img.style.cursor = cursor;
    }
}

module.exports = {
    pile_game_ui: pile_game_ui_browser,
    pile_ui: pile_ui_browser,
    card_ui: card_ui_browser,
    grid: piles_ui.grid
};
